<template>
  <section class="my-5 pb-5">
    <p class="is-size-2 has-text-weight-semibold is-text-align-center mb-3">
      {{ title }}
    </p>
    <p class="is-size-5 has-text-centered">
      {{ description }}
    </p>
  </section>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesResultHeader',
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  }
};
</script>
